export type AppliesToModeValues = {
  appliesToAllProducts: boolean;
  filterByProducts: boolean;
  filterByTags: boolean;
};

export const appliesToModeFromLists = ({
  appliesToAllProducts,
  productCount,
  tagCount
}: {
  appliesToAllProducts?: boolean;
  productCount: number;
  tagCount: number;
}): AppliesToModeValues => {
  const isAll = appliesToAllProducts ?? (productCount === 0 && tagCount === 0);
  if (isAll) {
    return { appliesToAllProducts: true, filterByProducts: false, filterByTags: false };
  }
  const hasProducts = productCount > 0;
  const hasTags = tagCount > 0;
  return {
    appliesToAllProducts: false,
    filterByProducts: hasProducts || !hasTags,
    filterByTags: hasTags || !hasProducts
  };
};

export const appliesToIdsForSubmit = ({
  mode,
  productIds,
  tagIds
}: {
  mode: AppliesToModeValues;
  productIds: number[];
  tagIds: number[];
}): { productIds: number[]; tagIds: number[] } => ({
  productIds: mode.appliesToAllProducts || !mode.filterByProducts ? [] : productIds,
  tagIds: mode.appliesToAllProducts || !mode.filterByTags ? [] : tagIds
});
